var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AssetsTable',{attrs:{"smaller-gap-bottom":"","display-has-label":false,"with-title":false,"no-border":"","select-item-route":_vm.selectItemRoute,"sort-order":_vm.sortOrder}})
}
var staticRenderFns = []

export { render, staticRenderFns }